<template>
  <div class="driver-background-page">
    <el-descriptions :column="2" label-position="left" label-width="120px" size="medium" border
      style="margin-bottom: 16px;">
      <el-descriptions-item label="报告编号" :span="2">
        <div class="flex" style="justify-content: space-between;">
          <span @dblclick="$utils.dblclickCopy">{{ adverseRecord.code || '-' }}</span>
          <el-button type="primary" @click="postAdverseRecord">查询</el-button>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="司机姓名">
        <span @dblclick="$utils.dblclickCopy">{{ driverInfo.name || '-' }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="联系电话">
        <span @dblclick="$utils.dblclickCopy">{{ driverInfo.phone || '-' }}</span>
      </el-descriptions-item>
      <!-- 身份证号 -->
      <el-descriptions-item label="身份证号">
        <span @dblclick="$utils.dblclickCopy">{{ driverInfo.idCard || '-' }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="生成时间">
        <span>{{ adverseRecord.updated | filterTime }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="审核结果" :span="2">
        <div class="suggestedAction" v-if="adverseRecord.score !== null">
          <div class="dot" :style="{ backgroundColor: adverseRecord.score < 20 ? '#67c23a' : '#f56c6c' }"></div>
          <span>{{ adverseRecord.score < 20 ? '通过' : '未通过' }}</span>
        </div>
        <div v-else>-</div>
      </el-descriptions-item>
      <el-descriptions-item label="风险等级">
        <div v-if="currentRiskLevel">
          <el-tag :type="currentRiskLevel.tag">{{ currentRiskLevel.riskLevel }}</el-tag>
        </div>
        <div v-else>-</div>
      </el-descriptions-item>
      <el-descriptions-item label="风险分值">
        <div v-if="adverseRecord.hit === 0">0</div>
        <div v-else-if="adverseRecord.score || adverseRecord.score === 0">{{ adverseRecord.score }}</div>
        <div v-else>-</div>
      </el-descriptions-item>
      <el-descriptions-item label="风险说明">
        <span>{{ currentRiskLevel ? currentRiskLevel.riskDesc : '-' }}</span>
      </el-descriptions-item>

    </el-descriptions>

    <div class="table-container" v-loading="loading">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="riskValue" label="风险分值" width="100"></el-table-column>
        <el-table-column prop="riskLevel" label="风险等级" width="90">
          <template #default="scope">
            <el-tag :type="scope.row.tag">{{ scope.row.riskLevel }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="riskDesc" label="风险说明"></el-table-column>
        <el-table-column prop="legalBasis" label="法律依据"></el-table-column>
        <el-table-column prop="suggestedAction" label="录用建议" width="100">
          <template #default="scope">
            <div class="suggestedAction" :style="{ color: scope.row.color }">
              <div class="dot" :style="{ backgroundColor: scope.row.color }"></div>
              <span>{{ scope.row.suggestedAction }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
/**
 * @description 驾驶员背景审核页面组件
 */
export default {
  name: 'DriverBackgroundPage',
  data() {
    return {
      info: {},
      /**
       * @description 表格数据
       */
      tableData: [
        {
          riskValue: '80≤分值＜100',
          riskLevel: '严重风险',
          riskDesc: '在逃、危害国家安全、破坏经济秩序、金融诈骗、经济犯罪等;在刑或前科',
          legalBasis: '《最高人民法院关于审理黑社会性质组织犯罪案件适用法律若干问题的解释》等',
          suggestedAction: '不予注册',
          color: '#f56c6c',
          tag: 'danger'
        },
        {
          riskValue: '60≤分值＜80',
          riskLevel: '高风险',
          riskDesc: '制贩毒、严重暴力犯罪、涉黑犯罪、涉枪、涉爆炸、拐卖妇女、侵犯财产等;在刑或前科',
          legalBasis: '《刑法》相关条款',
          suggestedAction: '不予注册',
          color: '#f56c6c',
          tag: 'danger'
        },
        {
          riskValue: '40≤分值＜60',
          riskLevel: '中风险',
          riskDesc: '非正常上访、肇事、闹事、精神病犯罪等',
          legalBasis: '相关行政法规',
          suggestedAction: '不予注册',
          color: '#f56c6c',
          tag: 'danger'
        },
        {
          riskValue: '30≤分值＜40',
          riskLevel: '中低风险',
          riskDesc: '法律文书（包括但不限于刑事或民事记录，一般是刑事案件）',
          legalBasis: '相关法律文书',
          suggestedAction: '谨慎评估',
          color: '#909399',
          tag: 'info'
        },
        {
          riskValue: '20≤分值＜30',
          riskLevel: '低风险',
          riskDesc: '涉稳、涉恐',
          legalBasis: '相关规定',
          suggestedAction: '谨慎评估',
          color: '#e6a23c',
          tag: 'warning'
        },
        {
          riskValue: '0＜分值＜20',
          riskLevel: '轻微风险',
          riskDesc: '其他（可能包含行政拘留、罚款、劳动教养等）',
          legalBasis: '行政处罚法',
          suggestedAction: '可以注册',
          color: '#67c23a',
          tag: 'success'
        },
        {
          riskValue: '0',
          riskLevel: '正常',
          riskDesc: '无不良记录',
          legalBasis: '-',
          suggestedAction: '可以注册',
          color: '#67c23a',
          tag: 'success'
        }
      ],
      loading: false
    }
  },
  props: {
    driverInfo: {
      type: Object,
      required: true
    },
    adverseRecord: {
      type: Object,
      required: true
    },
    searchShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    /**
     * 当前风险等级对象，避免在模板中使用可选链导致解析错误
     */
    currentRiskLevel() {
      return this.getRiskLevel(this.adverseRecord && this.adverseRecord.score)
    }
  },
  created() {
  },
  methods: {
    async postAdverseRecord() {
      this.$confirm("确定要查询吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.loadingTraining = true;
        const url = "/api/v1/manage/driver/adverse/record";
        const { code } = await this.$axios.post(url, {
          driverId: this.driverInfo.id,
        });
        if (code === 1) {
          this.$message.success("查询成功");
          this.$emit('submitSuccess')
        }
        this.loadingTraining = false;
      })
    },

    /**
     * @description 根据分数获取风险等级
     * @param {number} score 分数
     * @returns {Object} 对应区间的风险数据
     */
    getRiskLevel(score) {// 处理特殊情况：分数为0
      if (score === null) {
        return {
          riskLevel: '-',
          riskDesc: '-',
          suggestedAction: '-',
        }
      }
      if ((this.adverseRecord.hit !== undefined && this.adverseRecord.hit === 0) || score === 0 || score === "") {
        return this.tableData.find(item => item.riskValue == '0');
      }

      // 遍历tableData检查分数是否在区间内
      for (const item of this.tableData) {
        // 跳过'分值=0'的情况，已经在上面处理
        if (item.riskValue == '0') continue;

        // 解析区间字符串，例如'80≤分值＜100'或'0＜分值＜20'
        let min, max;

        // 处理 'X≤分值＜Y' 格式
        const matchFormat1 = item.riskValue.match(/(\d+)≤分值＜(\d+)/);
        if (matchFormat1) {
          min = parseFloat(matchFormat1[1]);
          max = parseFloat(matchFormat1[2]);
        } else {
          // 处理 'X＜分值＜Y' 格式
          const matchFormat2 = item.riskValue.match(/(\d+)＜分值＜(\d+)/);
          if (matchFormat2) {
            min = parseFloat(matchFormat2[1]);
            max = parseFloat(matchFormat2[2]);
            // 注意: X＜分值，意味着min是开区间，要加上一个极小值
            min += 0.000001;
          }
        }

        // 检查分数是否在区间内
        if (min !== undefined && max !== undefined) {
          if (score >= min && score < max) {
            return item;
          }
        }
      }

      // 如果没有找到匹配的区间，返回null
      return null;
    },
  }
}
</script>

<style lang="less" scoped>
.driver-background-page {

  :deep(.el-descriptions) {
    border-radius: 8px;
    position: relative;
    overflow: hidden;
  }

  :deep(.el-descriptions)::after {
    content: '';
    pointer-events: none;
    position: absolute;
    inset: 0;
    border-radius: 8px;
    border: 1px solid #EBEEF5;
    z-index: 1;
  }

  :deep(.el-descriptions-row) {
        display: flex;
    }

    :deep(.el-descriptions-item__cell) {
        border-top: 0;
        border-left: 0;
    }

    :deep(.el-descriptions-item__label.is-bordered-label) {
        width: 150px;
        flex-shrink: 0;
        background-color: #FBFBFB;
    }

    :deep(.el-descriptions-item__content) {
        flex: 1;
    }

  .table-container {
    margin-top: 20px;

    .el-tag {
      width: 60px;
      text-align: center;
    }
  }

  .suggestedAction {
    display: flex;
    align-items: center;

    .dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 5px;
    }
  }

}
</style>